import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { HomePage } from '../home/home';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  loginForm: FormGroup;
  submitAttempt: boolean = false;
  loading;

  constructor(public asf: AngularFirestore, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public FireAuth: AngularFireAuth) {
    this.isLoggedIn();
    this.loginForm = formBuilder.group({
      email: ['', Validators.compose([Validators.maxLength(45), Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/), Validators.required])],
      password: ['', Validators.compose([Validators.minLength(6)])]
    });
  }

  ionViewDidLoad() { }

  login() {
    this.submitAttempt = true;
    if (this.loginForm.valid) {
      this.presentLoading();
      this.FireAuth.auth.signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password).then((usuario) => {
        if (usuario && usuario.uid) {
          this.asf.doc("Users/" + usuario.uid).ref.get().then(document => {
            if (document.exists) {
              this.loading.dismiss();
              this.navCtrl.setRoot(HomePage);
            } else {
              this.loading.dismiss();
              this.FireAuth.auth.signOut();
              let alert = this.alertCtrl.create({
                subTitle: 'Usuario no existente',
                buttons: ['Ok']
              });
              alert.present();
            }
          }).catch(error => {
            //console.error(error);
            this.loading.dismiss();
            this.FireAuth.auth.signOut();            
            let alert = this.alertCtrl.create({
              subTitle: 'Error desconocido',
              buttons: ['Ok']
            });
            alert.present();
          });
        }
      }).catch(error => {
        this.loading.dismiss();
        let subTitle = "Error desconocido";
        if (error.code == 'auth/user-not-found') {
          subTitle = "La cuenta no existe";
        } else if (error.code == 'auth/wrong-password') {
          subTitle = "Contraseña incorrecta";
        } else if (error.code == 'auth/user-disabled') {
          subTitle = "Cuenta deshabilitada";
        }
        let alert = this.alertCtrl.create({
          subTitle: subTitle,
          buttons: ['Ok']
        });
        alert.present();
      });
    }
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    this.loading.present();
  }

  isLoggedIn() {
    this.FireAuth.authState.subscribe(res => {
      if (res && res.uid) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  forgotPassword() {
    this.navCtrl.push(ForgotPasswordPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts